/* eslint-disable camelcase */
import { stringify } from 'qs';

import { httpClient } from '@/domains/core/httpClient/httpClient';
import logger from '@/domains/core/observability/logger';
import { getAppSetting } from '@/domains/core/settings/appSettings';
import { getMarket, getPlatform } from '@/domains/core/settings/utils';

export interface ICouponsQueryParams {
  sellerId?: number;
  modelIds?: number[];
}

export interface ICouponFromApi {
  code: string;
  value: number;
  end_time: string;
  is_percentage: boolean;
  min_price: number;
}

interface ICouponEligibilityResponse {
  content: ICouponFromApi[];
}

const fetchBundleCoupons = async ({
  sellerId,
  modelIds,
}: ICouponsQueryParams): Promise<ICouponFromApi[]> => {
  const params = stringify({
    platform: getPlatform(),
    market: getMarket(),
    seller_id: sellerId,
    model_ids: modelIds ? modelIds.join(',') : undefined,
  });

  try {
    const response = await httpClient.get<ICouponEligibilityResponse>(
      `${getAppSetting('MS_COUPON_WEB')}/api/v1/coupon-eligibility/bundle-coupons?${params}`,
      {
        timeout:
          parseInt(
            getAppSetting('PRODUCT_PAGE_API_SERVICE_TIMEOUT') as string,
            10,
          ) || 3000,
      },
    );

    return response.data?.content;
  } catch (error) {
    logger.error(new Error('Error fetching bundle coupons'));

    return [];
  }
};

export default fetchBundleCoupons;
